import React from "react";

const Panel = ({ name, children }) => (
  <section className="module">
    <header className="module__header">
      <h2 className="module__title">{name}</h2>
    </header>
    {children}
  </section>
);

export class PanelCollapsible extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      expanded: props.expand || false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.setState(prevState => ({ expanded: !prevState.expanded }));
  }

  render() {
    let { name } = this.props;

    return (
      <section className="module">
        <button
          type="button"
          onClick={this.handleClick}
          className="module__header"
        >
          <h2 className="module__title">
            <ExpandIcon expanded={this.state.expanded} />
            {name}
          </h2>
        </button>
        {this.renderChildren()}
      </section>
    );
  }

  renderChildren() {
    return this.state.expanded ? this.props.children : null;
  }
}

const ExpandIcon = ({ expanded }) => {
  let iconClass = expanded ? "glyphicon-menu-down" : "glyphicon-menu-up";

  return <i className={`glyphicon ${iconClass}`} />;
};

export default Panel;
